import { render, staticRenderFns } from "./ClosedPositions.vue?vue&type=template&id=69aebb00"
import script from "./ClosedPositions.vue?vue&type=script&lang=js"
export * from "./ClosedPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports